

const constants = {
    formname: "upload-audio",
    title: "העלאת מבדק"
}

export default constants